let blockCount = 0

export default {
  install (Vue) {
    let lastScrollY = 0
    Vue.prototype.$blockScroll = function (block) {
      blockCount += block ? 1 : -1

      if (block && blockCount > 1) return
      else if (!block && blockCount > 0) return

      if (block) lastScrollY = window.scrollY || window.pageYOffset
      document.body.style.position = block ? 'fixed' : 'relative'
      document.body.style.top = block ? `-${lastScrollY}px` : 'auto'

      if (!block) {
        window.scrollTo(0, lastScrollY)
        lastScrollY = 0
      }
    }
  }
}
